// Entry point for the build script in your package.json
import "./htmx.js"
import 'htmx-ext-ws';

// Progressive enhancement for View Transitions
// See: https://htmx.org/docs/#view-transitions
function useViewTransition(func) {
  if (document.startViewTransition) {
    // If the browser supports the View
    // Transitions API, use it
    document.startViewTransition(func);
  } else {
    func();
  }
}
window.useViewTransition = useViewTransition;

import "./helpers";
import "./controllers";
import "./rfx/add_providers_modal";
import './rfx/invite_participant_modal'
import './rfx/assign_concierge_modal'
import "./rfx/line_items_modal";
